export default "__VITE_ASSET__5836ab55__"